import { whitelabelThemes } from "./whitelabel-theme";

const palette = whitelabelThemes.default;

// Host-owned appearance shared by the Wellprept admin and doctor dashboards.
export const wellpreptChatBranding = {
  primary_color: palette.primary,
  primary_contrast_color: "#ffffff",
  surface_color: "#ffffff",
  text_color: "#111827",
  muted_color: "#6b7280",
  border_color: palette["primary-shades"]![100]!,
  assistant_background_color: palette["primary-shades"]![50]!,
  assistant_text_color: palette["primary-shades"]![800]!,
};

export const wellpreptChatIconUrl = new URL("../assets/agent-chat-wand.svg", import.meta.url).href;

export function applyWellpreptChatBranding(element: HTMLElement & {
  branding: typeof wellpreptChatBranding;
  showActionDetails: boolean;
}) {
  element.branding = { ...wellpreptChatBranding };
  element.showActionDetails = false;
  element.setAttribute("display-name", "Wellprept Assistant");
  element.setAttribute("logo-url", wellpreptChatIconUrl);
  element.setAttribute("launcher-icon-url", wellpreptChatIconUrl);
}
